// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._38gO7g_eHPFsB2 {\n  display: inline;\n  border-radius: 3px;\n  background-color: rgba(255, 255, 255, 0.69);\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  line-height: 16px;\n  align-items: center;\n  color: #172B4D;\n  width: -webkit-fit-content;\n  width: fit-content;\n  width: -moz-fit-content;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTemplateBadge": "_38gO7g_eHPFsB2"
};
export default ___CSS_LOADER_EXPORT___;
